package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/** DSL 文件头模式。 */
enum class DslMode { LEGACY, STRICT }

/** 顶层 `@allin(...)` 文件头。 */
data class DslHeaderAst(
    val version: Int = 1,
    val mode: DslMode = DslMode.LEGACY,
    override val position: SourcePosition,
) : AstNode {
    companion object {
        fun legacy(position: SourcePosition): DslHeaderAst =
            DslHeaderAst(version = 1, mode = DslMode.LEGACY, position = position)
    }
}
